import { AfterViewInit, Component, NgZone, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxContextMenuComponent,
  DxDataGridModule,
  DxFileUploaderModule,
  DxFormModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTextBoxModule,
  DxToastModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { TechnicalComponentsService } from 'src/app/services/tech-components.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { FileViewerComponent } from 'src/app/components/file-viewer/file-viewer.component';
import { ContactService } from 'src/app/services/contact.service';
import { SocietyService } from 'src/app/services/society.service';
import { ContactsDropdownBoxComponent } from 'src/app/components/contacts-dropdown-box/contacts-dropdown-box.component';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { ChangeDetectorRef } from '@angular/core';
import { FileViewerService } from 'src/app/services/file-viewer.service';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { FormFooterComponent } from 'src/app/components/form-footer/form-footer.component';
import { ContractsPillComponent } from 'src/app/components/contracts-pill/contracts-pill.component';
import {
  ComponentDetailsPanelComponent,
  SiteInfo,
  ProjectInfo,
} from 'src/app/components/component-details-panel/component-details-panel.component';
import { GpdPaginationComponent } from 'src/app/components/gpd-pagination/gpd-pagination.component';
import { AppConfig } from 'src/app/app.config';
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import { ContactsPopupComponent } from "src/app/components/contacts-popup/contacts-popup.component";
import { ValidationToastComponent } from 'src/app/components/validation-toast/validation-toast.component';
import { StatusPillComponent } from 'src/app/components/status-pill/status-pill.component';
import { ContractStatusConfig } from 'src/app/constants/status-pill-configs';
import { ProjectListService } from 'src/app/services/project-list.service';
import { LoggingService } from 'src/app/services/logging.service';


import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivityEntity, ActivitySection } from 'src/app/constants/activity-log';
import { SearchableDropdownDirective } from '../../directives/searchable-dropdown.directive';
import { ApiFileService } from 'src/app/services/api-file.service';
@Component({
    selector: 'app-technical-components',
    templateUrl: './technical-components.page.html',
    styleUrls: ['./technical-components.page.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        DxButtonModule,
        DxNumberBoxModule,
        RouterModule,
        DxDataGridModule,
        DxPopupModule,
        DxFormModule,
        DxFileUploaderModule,
        DxToastModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxValidationGroupModule,
        ContactsDropdownBoxComponent,
        DxSwitchModule,
        GpdButtonComponent,
        FormFooterComponent,
        ContractsPillComponent,
        ComponentDetailsPanelComponent,
        GpdPaginationComponent,
        SvgIconComponent,
        ContactsPopupComponent,
        ValidationToastComponent,
        StatusPillComponent,
        SearchableDropdownDirective,
    ]
})
export class TechnicalComponentsComponent implements AfterViewInit {
  private readonly apiFileService = inject(ApiFileService);

  readonly contractStatusConfig = ContractStatusConfig;
  @ViewChild('docFileInput') docFileInput: any;
  @ViewChild('validationToast') validationToast: ValidationToastComponent;
  @ViewChild('techValidationGroup') techValidationGroup: any;

  type: any = "";
  allDataFields: any[] = [];
  showDeleteRestrictionPopup: boolean = false;
  message: any = '';
  toastVisible: boolean = false;

  searchTerm: string = AppGlobals.searchPanelText;

  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  @ViewChild(DxContextMenuComponent, { static: false }) contextMenu!: DxContextMenuComponent;

  contextMenuTarget: any;
  selectedRowData: any;
  documentList: any = [];

  contentLoadedVisible: boolean = true;

  popUpTitle: string = $localize`:@@title:Title`;

  editComponentVisible: boolean = false;
  detailsPanelVisible: boolean = false;

  allowDeletingVisible: boolean = false;

  addNewComponentVisible: boolean = false;

  addComponentVisible: boolean = false;

  popupVisible: boolean = false;
  currentShowing: string = '1';
  totalItems: number = 0;
  itemsPerPage: number = 0;
  showFileUploadedName: boolean = false;

  uploadDocumentVisible: boolean = false;
  fileUploadedName: string = '';

  labelBtnUploadDocument: string = $localize`:@@uploadDocumentCaps:UPLOAD DOCUMENT`;
  labelBtnAddDocument: string = $localize`:@@addDocumentCaps:ADD DOCUMENT`;

  disableType: boolean = false;
  // disableManufacturer: boolean = false;
  // disableModel: boolean = false;
  componentList: any = [];

  isGridHidden: boolean = true;
  isFormHidden: boolean = false;

  companies: any = [];
  persons: any = [];
  componentId: number | null = null;
  itemToDelete: any;
  deletePopupVisible: boolean = false;
  deleteMessage: string = $localize`Do you want to delete this Component?`;
  selectedComponent: any = {
    manufacturerId: null,
    manufacturerName: null,
    type: null,
    model: null,
    powerRating: null,
    hasDataSheet: null,
    notes: null,
  };

  selectedTypeId: number | null = null;
  typeName: string = '';
  componentTypes: any = [];
  componentInfo: any = [];
  showDuplicateMessage: boolean = false;
  statusOptions: any = [
    { value: 'Active', text: $localize`:@@active:Aktiv` },
    { value: 'Inactive', text: $localize`:@@inactive:Inaktiv` },
  ];
  companyList: any = {};
  personsList: any = {};

  projectId: any = '';
  selectedComponentIdForDocUpload: any = '';
  componentTypeLists: any = [];

  isComponentTypeSelected: boolean = false;
  company: any = 'company';
  documentName: string = 'doc';
  compName: string = '';
  modell: string = '';
  manufacturerId: number | null = null;
  selectedStatus: string = 'Active';
  isEdit: boolean = false;
  isCompleted: boolean = false;
  isCompleting: boolean = false;
  model: string = '';

  get allRequiredFieldsFilled(): boolean {
    if (!this.model || this.model.trim() === '') return false;
    if (!this.manufacturerId) return false;
    if (!this.selectedTypeId) return false;
    if (this.dynamicDataFields.some(
      field => field.required && (field.dataValue === null || field.dataValue === undefined || field.dataValue === '')
    )) return false;

    const requiredDocs = this.documentList.filter(
      // eslint-disable-next-line eqeqeq
      doc => doc.techComponentTypeId == this.selectedTypeId && doc.required
    );
    const allRequiredDocsUploaded = requiredDocs.every(doc => {
      if (this.isEdit) {
        // eslint-disable-next-line eqeqeq
        return !!this.doclinks?.find(dl => dl.docId == doc.id && dl.componentId == this.componentId && dl.docLink);
      }
      return this.pendingDocumentUploads.has(doc.id);
    });

    return allRequiredDocsUploaded;
  }

  get isSaveDisabled(): boolean {
    if (!this.isEdit || !this.isCompleted) return false;
    return !this.allRequiredFieldsFilled;
  }

  dynamicColumns: any[] = [];
  private _dynamicDataFields: any[] = [];

  // Pairs the manufacturer field with the dynamic type fields, two per row (left/right),
  // matching the shared .gpd-form-row layout - never a lone field with an empty half next to it.
  // Recomputed only when dynamicDataFields is reassigned (via the setter below), not on every
  // change-detection cycle: a template getter here would return new row/array identities each
  // tick, so *ngFor would tear down and rebuild the DevExtreme editors constantly, wiping any
  // validation state (dx-invalid) the moment it was set.
  detailFieldRows: any[][] = [[{ isManufacturerField: true }]];

  get dynamicDataFields(): any[] {
    return this._dynamicDataFields;
  }

  set dynamicDataFields(fields: any[]) {
    this._dynamicDataFields = fields || [];
    const allFields: any[] = [{ isManufacturerField: true }, ...this._dynamicDataFields];
    const rows: any[][] = [];
    for (let i = 0; i < allFields.length; i += 2) {
      rows.push(allFields.slice(i, i + 2));
    }
    this.detailFieldRows = rows;
  }

  techDatumList: any = [];
  viewDetails: any = {};
  filteredSiteIds: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;

  siteComponents: any = {};
  projectComponents: any = {};
  pendingDocumentUploads: Map<number, File> = new Map(); // docId -> File
  filteredSiteQuantities: number[] = [];

  dynamicPageSize: number = 20; // Default fallback
  rowHeight: number = 40; // Approximate height of each row in pixels
  headerHeight: number = 40; // Height of grid header
  toolbarHeight: number = 60; // Height of bottom toolbar
  availableHeight: number = 0;
  detailsPanelHeight: number = 0; // Height for details panel to match grid

  fileUploadComplete: boolean = false;
  pageBreadCrumb: any = {
    text: $localize`Technical Components/`,
    href: window.location.href,
    layer: 0,
  };

  file: File;

  @ViewChild(FileViewerComponent) fileViewer: FileViewerComponent;
  @ViewChild(ContactsPopupComponent) contactsPopup: ContactsPopupComponent;

  contactsPopupVisible: boolean = false;
  popupReturnTarget: any = null;
  isPopupForManufacturer: boolean = false;

  targetItem: any;

  selectedTaskId: any;

  selectComponentTypePlaceholder: string = $localize`:@@selectComponentType:Select Component Type`;

  constructor(
    private societyService: SocietyService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
    private appGlobals: AppGlobals,
    readonly technicalComponentsService: TechnicalComponentsService,
    private contactService: ContactService,
    private cdr: ChangeDetectorRef,
    private fileViewerService: FileViewerService,
    private projectListService: ProjectListService,
    private loggingService: LoggingService,
    private activityLog: ActivityLogService
  ) {}

  private projectStatusById: Map<number, string> = new Map();

  private async loadProjectStatusMap(): Promise<void> {
    try {
      const result = await this.projectListService.getProjectList({});
      const list = result?.projectList ?? [];
      this.projectStatusById = new Map(list.map((p) => [p.id, p.status]));
    } catch {
      this.projectStatusById = new Map();
    }
  }

  private getProjectStatus(projectId: number): string | null {
    return this.projectStatusById.get(Number(projectId)) ?? null;
  }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.COMPONENTS });
    this.isGridHidden = false;
    this.isFormHidden = true;
    AppGlobals.clearBreadCrumbInLocalStorage();
    this.searchTerm = '';
    this.projectId = parseInt(this.activatedRoute.snapshot.params.id);

    this.appGlobals.$headerTitle.next($localize`:@@technicalComponents:Technical Components`);
    this.loadPageData();
    console.clear();
  }

  ngAfterViewInit(): void {
    this.calculateDynamicPageSize();
    this.getGridPageInfo();
    window.addEventListener('resize', () => {
      this.calculateDynamicPageSize();
    });
  }

  switchChanged: boolean = false;
  onSelectionChanged(e: any): void {
    this.switchChanged = false;
    this.detailsPanelVisible = false; // Hide details panel when switch is toggled
    if (!e.selectedItem) {
      this.dataGrid.instance.clearFilter();
      this.dynamicColumns = [];
      return;
    }
    const selectedTypeId = Number(e.selectedItem.id);
    this.typeName = e.selectedItem.name;

    this.dynamicColumns = this.componentTypeDataList.filter(
      field => field.techComponentTypeId === selectedTypeId && field.showInTable === true
    );

    // Apply filter to show only components of the selected type and status 'Active'
    if (this.dataGrid && this.dataGrid.instance) {
      this.dataGrid.instance.filter([['typeId', '=', selectedTypeId]]);
    }
  }

  exportToExcel(): void {
    if (!this.dataGrid?.instance) {
      console.warn('DataGrid not initialized');
      return;
    }
    let selectedRows = this.dataGrid.instance.getSelectedRowsData();
    if (!selectedRows || selectedRows.length === 0) {
      selectedRows = this.componentList; // Use all components if none selected
    }
    if (!selectedRows || selectedRows.length === 0) {
      return;
    }

    // Get visible columns from the grid
    const columns = this.dataGrid.instance.getVisibleColumns();
    const headerCaptions = columns.map(col => col.caption || col.dataField).filter(h => !!h);
    const dataFields = columns.map(col => col.dataField).filter(f => !!f);

    // Add extra columns for site quantity and sites used
    const extendedHeaderCaptions = [...headerCaptions, 'Anzahl', 'Standort'];

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Technical Components');
    worksheet.addRow(extendedHeaderCaptions);
    selectedRows.forEach(row => {
      // Find all siteComponents for this component
      const sitesForComponent = (this.siteComponents || []).filter(
        item => Number(item.componentId) === Number(row.componentId)
      );
      // Gather site names and quantities
      const siteNames = sitesForComponent.map(item => item.siteName).filter(name => !!name);
      const siteQuantities = sitesForComponent
        .map(item => {
          if (typeof item.siteQuantity === 'string') {
            const cleaned = item.siteQuantity.replace(/,/g, '').replace(/^0+/, '');
            return Number(cleaned);
          }
          return Number(item.siteQuantity);
        })
        .filter(qty => !isNaN(qty) && qty > 0);
      // Join site names and quantities for export
      const sitesUsedStr = siteNames.join(', ');
      const siteQuantityStr = siteQuantities.join(', ');

      worksheet.addRow([
        ...dataFields.map(f => {
          const value = row[f];
          return value !== null && value !== undefined ? value.toString() : '';
        }),
        siteQuantityStr,
        sitesUsedStr,
      ]);
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const filename = `TechnicalComponents_${Date.now()}.xlsx`;
      saveAs(new Blob([buffer]), filename);
      this.loggingService.logFileExport(buffer, filename, { section: ActivitySection.COMPONENTS });
      if (this.dataGrid?.instance) {
        this.dataGrid.instance.clearSelection();
      }
    });
  }

  showErrMsg: boolean = false;
  /** Set on a save/complete attempt; marks missing required documents inline. */
  showMissingDocErrors: boolean = false;
  errMsg: string = '';
  exportComponentData(): void {
    // Export selected components to Excel
    this.exportToExcel();

    // Get selected rows from the grid
    if (!this.dataGrid?.instance) {
      console.warn('DataGrid not initialized');
      return;
    }
    let selectedRows = this.dataGrid.instance.getSelectedRowsData();

    // If no selection, use all rows and download all docs as zip
    if (!selectedRows || selectedRows.length === 0) {
      if (this.allComponentIds.length === 0) {
        // Populate allComponentIds if not already done
        this.allComponentIds = this.componentList.map(c => c.componentId);
      }
      this.downloadAllComponentDocsAsZip();
      this.allComponentIds = []; // Reset after export
      return;
    } else if (selectedRows.length > 1) {
      this.allComponentIds = selectedRows.map(c => c.componentId);
      this.downloadAllComponentDocsAsZip();
      this.allComponentIds = []; // Reset after export
      return;
    }

    if (!selectedRows || selectedRows.length === 0) {
      this.showErrMsg = true;
      this.errMsg = $localize`:@@noComponentSelected:No components selected for export.`;
      this.allComponentIds = []; // Reset after export
      return;
    }

    // Download zipped documents for each selected component
    selectedRows.forEach((row, index) => {
      if (row.componentId) {
        setTimeout(() => {
          this.componentId = row.componentId;
          this.downloadZipped();
        }, index * 5000); // 5 seconds between downloads
      }
    });

    this.allComponentIds = []; // Reset after export
  }

  selectedTypeName: string = '';
  onComponentChosen(e: any): void {
    if (!e.selectedItem || !e.selectedItem.id) {
      this.selectedTypeId = null;
      this.selectedTypeName = '';
      this.isComponentTypeSelected = false;
      this.dynamicDataFields = [];
      return;
    }
    this.selectedTypeId = e.selectedItem.id;
    this.selectedTypeName = e.selectedItem.name;
    this.isComponentTypeSelected = true;

    // Only rebuild dynamicDataFields if NOT editing
    if (!this.isEdit) {
      this.dynamicDataFields = this.componentTypeDataList
        .filter(field => Number(field.techComponentTypeId) === this.selectedTypeId)
        .map(field => {
          let options: string[] = [];
          if (Array.isArray(field.userDefinedOptionList) && field.userDefinedOptionList.length > 0) {
            try {
              options = JSON.parse(field.userDefinedOptionList[0]);
            } catch {
              options = [];
            }
          } else if (field.userDefinedOptionList && typeof field.userDefinedOptionList === 'string') {
            try {
              options = JSON.parse(field.userDefinedOptionList);
            } catch {
              options = [];
            }
          }
          // For new component, no previous data
          return {
            ...field,
            dataValue: field.dataValue ?? '',
            options,
          };
        });
    }
  }

  onSwitchChange(e: any): void {
    this.detailsPanelVisible = false;

    // If switch is ON (e.value true), show all statuses (Active + Inactive).
    // If switch is OFF (e.value false), show only Active.
    if (this.selectedTypeId) {
      if (e.value) {
        // Show all statuses for selected type
        this.dataGrid.instance.filter([['typeId', '=', this.selectedTypeId]]);
      } else {
        // Show only Active for selected type
        this.dataGrid.instance.filter([['typeId', '=', this.selectedTypeId], 'and', ['status', '=', 'Active']]);
      }
    } else {
      if (e.value) {
        // Show all statuses for all types (no filter)
        this.dataGrid.instance.clearFilter();
      } else {
        // Show only Active for all types
        this.dataGrid.instance.filter([['status', '=', 'Active']]);
      }
    }

    this.onHeaderFilterChanged();
  }

  showAllComponents(): void {
    this.detailsPanelVisible = false;
    this.selectedTypeId = null; // "All" type selected
    this.typeName = '';
    this.searchTerm = '';
    this.isComponentTypeSelected = false;
    this.dynamicColumns = [];
    // if (this.dataGrid?.instance) {
    //   this.dataGrid.instance.clearFilter();
    //   this.dataGrid.instance.filter(['status', '=', 'Active']); // Show all active components
    // }
  }

  private rowClickTimer: any = null;

  async onRowClick(e: any) {
    // Ignore clicks on the selection checkbox
    if (
      e.event &&
      (e.event.target?.classList.contains('dx-checkbox-icon') || e.event.target?.classList.contains('dx-checkbox'))
    ) {
      return;
    }

    // Omit the cell with the edit pencil (buttonCellTemplate)
    if (e.column && e.column.cellTemplate === 'buttonCellTemplate') {
      return;
    }

    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
      this.rowClickTimer = null;
      this.componentInfo = e.data;
      this.componentId = e.data.componentId;
      this.editComponent();
      return;
    }

    this.rowClickTimer = setTimeout(async () => {
      this.rowClickTimer = null;
      this.componentInfo = e.data;
      this.componentId = e.data.componentId;
      this.populateFilteredProjects(this.componentId);
      this.viewDetails = {
        name: this.componentInfo.name,
        manufacturerName: this.componentInfo.manufacturerName,
        model: this.componentInfo.model,
        type: this.componentInfo.type,
        status: this.componentInfo.status,
      };

      this.displaySiteComponentForType(this.componentInfo.typeId);
      await this.getComponentDetails(this.componentId);
      this.detailsPanelVisible = true;
      this.getDocsForThisComponent();
      this.dataGrid?.instance?.repaint();
    }, 250);
  }

  closeDetailsPanel(): void {
    this.detailsPanelVisible = false;
    this.dataGrid?.instance?.repaint();
  }

  directToEdit(rowData: any, dxEvent: any) {
    if (dxEvent && dxEvent.event) {
      dxEvent.event.stopPropagation();
    }
    // Your edit logic here
    this.componentInfo = rowData;
    this.componentId = rowData.componentId;
    this.editComponent();
  }

  filteredSiteNames: any = [];
  siteQuantity: any = [];
  filteredProjectIds: any = [];
  filteredProjectNames: any = [];
  filteredProjectStatuses: any = [];
  displaySiteComponentForType(typeId: number): void {
    if (!this.siteComponents || !typeId || !this.componentId) {
      this.filteredSiteIds = [];
      this.filteredSiteNames = [];
      this.siteQuantity = 0;
      this.filteredProjectIds = [];
      this.filteredProjectNames = [];
      this.filteredProjectStatuses = [];
      return;
    }

    if (!this.projectComponents || !typeId || !this.componentId) {
      this.filteredProjectIds = [];
      this.filteredProjectNames = [];
      this.filteredProjectStatuses = [];
      this.siteQuantity = 0;
      return;
    }
    // Only show site info for the current componentId and typeId
    const filtered = this.siteComponents.filter(
      item => Number(item.typeId) === Number(typeId) && Number(item.componentId) === Number(this.componentId)
    );

    // Deduplicate by projectId
    const filteredProjects = this.projectComponents.filter(
      item => Number(item.typeId) === Number(typeId) && Number(item.componentId) === Number(this.componentId)
    );
    const uniqueProjectsMap = new Map();
    filteredProjects.forEach(item => {
      if (item.projectId !== undefined && item.projectId !== null && !uniqueProjectsMap.has(item.projectId)) {
        uniqueProjectsMap.set(item.projectId, item.projectName || item.projectId);
      }
    });
    this.filteredProjectIds = Array.from(uniqueProjectsMap.keys());
    this.filteredProjectNames = Array.from(uniqueProjectsMap.values());
    this.filteredProjectStatuses = this.filteredProjectIds.map((id) => this.getProjectStatus(id));

    // Deduplicate by siteId
    const uniqueSitesMap = new Map();
    filtered.forEach(item => {
      if (item.siteId !== undefined && item.siteId !== null && !uniqueSitesMap.has(item.siteId)) {
        uniqueSitesMap.set(item.siteId, item.siteName);
      }
    });
    this.filteredSiteIds = Array.from(uniqueSitesMap.keys());
    this.filteredSiteNames = Array.from(uniqueSitesMap.values());
    // Build filteredSiteQuantities to match filteredSiteIds order
    this.filteredSiteQuantities = this.filteredSiteIds.map(siteId => {
      const siteObj = filtered.find(item => item.siteId === siteId);
      return siteObj ? siteObj.siteQuantity : 0;
    });

    // Sum all site quantities for this component
    const totalQuantity = filtered.reduce((sum, item) => {
      let qty = 0;
      if (typeof item.siteQuantity === 'string') {
        // Remove commas and leading zeros, then parse
        const cleaned = item.siteQuantity.replace(/,/g, '').replace(/^0+/, '');
        qty = Number(cleaned);
      } else {
        qty = Number(item.siteQuantity);
      }
      return !isNaN(qty) && qty > 0 ? sum + qty : sum;
    }, 0);

    this.siteQuantity = totalQuantity;
  }

  goToProject(projectId: number): void {
    const projectComponent = this.projectComponents.find((item: any) => Number(item.projectId) === Number(projectId));
    const gId = projectComponent ? projectComponent.siteId : null;

    if (gId) {
      this.ngZone.run(() => {
        this.router.navigate([`/site/${gId}/project/${projectId}/projectInfo/components`]);
      });
    } else {
      // AppGlobals.ShowErrorMessage('Site ID not found for this project.');
      this.showErrMsg = true;
      this.errMsg = $localize`:@@siteIdNotFound:Site ID not found for this project.`;
    }
  }

  getGridPageInfo(): void {
    if (!this.dataGrid?.instance) {
      console.warn('DataGrid not initialized');
      return;
    }
    this.currentPage = this.dataGrid.instance.pageIndex() + 1;
    this.itemsPerPage = this.dataGrid.instance.getVisibleRows().length;
    this.totalPages = this.dataGrid.instance.pageCount();
  }

  // Update onContentReady
  onContentReady(): void {
    this.totalPages = this.dataGrid.instance.pageCount();
    this.getGridPageInfo();
  }

  // Optional: Add method to handle when filters change the available data
  onHeaderFilterChanged(): void {
    this.itemsPerPage = this.dataGrid.instance.getVisibleRows().length;
    this.totalPages = this.dataGrid.instance.pageCount();
    this.currentPage = this.dataGrid.instance.pageIndex() + 1;
  }

  // Clean up listener on destroy
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.calculateDynamicPageSize.bind(this));
  }

  // onContentReady(): void {
  //   this.totalPages = this.dataGrid.instance.pageCount();
  // }

  /**
   * Returns the current page index (1-based for display)
   */
  getCurrentPage(): number {
    if (!this.dataGrid?.instance) {
      return this.dataGrid.instance.pageIndex() + 1;
    }
    return 1;
  }

  /**
   * Advances to the next page in the data grid
   */
  goToNextPage(): void {
    if (this.dataGrid?.instance) {
      const currentIndex = this.dataGrid.instance.pageIndex();
      const totalPages = this.dataGrid.instance.pageCount();
      if (currentIndex < totalPages - 1) {
        this.dataGrid.instance.pageIndex(currentIndex + 1);
        this.getGridPageInfo();
      }
    }
  }

  get totalItemsForSelectedType(): number {
    if (!this.selectedTypeId) {
      // If no type selected, show all items
      return this.flattenedComponents.length;
    }
    return this.flattenedComponents.filter(c => c.typeId === this.selectedTypeId).length;
  }

  goToLastPage(): void {
    if (this.dataGrid?.instance) {
      const totalPages = this.dataGrid.instance.pageCount();
      this.dataGrid.instance.pageIndex(totalPages - 1);
      this.getGridPageInfo();
    }
  }

  // onHeaderFilterChanged(): void {
  //   this.itemsPerPage = this.dataGrid.instance.getVisibleRows().length;
  // }

  /**
   * Goes to the previous page in the data grid
   */
  goToPreviousPage(): void {
    if (this.dataGrid?.instance) {
      const currentIndex = this.dataGrid.instance.pageIndex();
      if (currentIndex > 0) {
        this.dataGrid.instance.pageIndex(currentIndex - 1);
        setTimeout(() => {
          this.getGridPageInfo();
        }, 500);
      }
    }
  }

  getAllTechComponentTypes(): void {
    this.technicalComponentsService.getAllTechComponentTypes({}).then(result => {
      this.componentTypeLists = result.componentTypeList
        .map(item => ({
          ...item,
          name: item.name, // No uppercase conversion
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getComponentDocsList(): void {
    this.technicalComponentsService.getComponentTypeDocs({}).then(result => {
      this.documentList = result.documents;
    });
  }

  goBack(): void {
    this.showDuplicateMessage = false;
    this.isGridHidden = false;
    this.isFormHidden = true;
    this.detailsPanelVisible = false;
    this.dataGrid.instance.filter([['typeId', '=', this.selectedTypeId], 'and', ['status', '=', 'Active']]);
    this.componentId = null;
    this.appGlobals.$logItemId.next(null);
    this.selectedComponent = {
      manufacturerId: null,
      manufacturerName: null,
      type: null,
      model: null,
    };
    this.disableType = false;
    this.isCompleted = false;
    this.isCompleting = false;
    this.showMissingDocErrors = false;
    // this.disableManufacturer = false;
    // this.disableModel = false;
    this.dynamicColumns = [];

    // NEW: Clear pending uploads when canceling
    this.pendingDocumentUploads.clear();
  }

  getVisiblePages(info: any): (number | string)[] {
    const current = info.pageIndex;
    const total = info.pageCount;
    const delta = 2;

    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i);
    }

    const pages: (number | string)[] = [];

    if (current <= delta + 1) {
      for (let i = 0; i <= Math.min(delta * 2 + 1, total - 1); i++) {
        pages.push(i);
      }
      if (total > delta * 2 + 2) {
        pages.push('...');
        pages.push(total - 1);
      }
    } else if (current >= total - delta - 1) {
      pages.push(0);
      if (total > delta * 2 + 2) {
        pages.push('...');
      }
      for (let i = Math.max(total - delta * 2 - 1, 1); i < total; i++) {
        pages.push(i);
      }
    } else {
      pages.push(0);
      pages.push('...');
      for (let i = current - delta; i <= current + delta; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(total - 1);
    }

    return pages;
  }

  flattenedComponents: any = [];

  loadPageData(): void {
    this.getComponentDocsList();
    this.getAllTechComponentTypes();
    this.getDataFields();
    this.getAllSiteComponents();
    this.getAllDocLinks();
    // this.getAllTechDatum();
    this.getContacts();

    this.loadCompanies();
    this.loadTechComponents();
  }

  private loadCompanies(): void {
    this.contactService.getCompanies({}).then(this.handleCompanyResult.bind(this)).catch(this.handleError);
  }

  private handleCompanyResult(result: any): void {
    if (result.hasError) {
      AppGlobals.ShowErrorMessage(result.feedback);
    } else {
      this.companies = result.companyItems;
    }
  }

  private loadTechComponents(): void {
    this.technicalComponentsService
      .getTechComponents({})
      .then(this.handleTechComponentsResult.bind(this))
      .catch(this.handleError);
  }

  private handleTechComponentsResult(result: any): void {
    if (result.hasError) {
      AppGlobals.ShowErrorMessage(result.feedback);
      return;
    }

    this.componentList = result.components;
    this.componentTypeLists = result.componentTypes
      .map(item => ({
        ...item,
        name: item.name, // Keep original casing
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
    this.flattenedComponents = this.flattenComponents(this.componentList).sort((a, b) => {
      const modelA = a.model || '';
      const modelB = b.model || '';
      return modelA.localeCompare(modelB);
    });
    this.totalItems = this.flattenedComponents.length; // <-- Set here, immediately after building

    this.cdr.detectChanges();
    setTimeout(() => {
      this.dataGrid?.instance?.filter(['status', '=', 'Active']);
      this.itemsPerPage = this.dataGrid?.instance?.getVisibleRows().length || 0;
    });

    // Query param search logic moved here to ensure componentList is loaded
    this.activatedRoute.queryParams.subscribe(params => {
      const componentId = params['componentId'];

      if (componentId && this.componentList && this.componentList.length > 0) {
        const comp = this.componentList.find(c => String(c.componentId) === String(componentId));
        if (comp) {
          this.searchTerm = comp.model;
          // Trigger the search
          this.doSearch({ value: comp.model });
        }
      }
    });
  }

  private flattenComponents(components: any[]): any[] {
    return components.map(component => {
      const { techComponentData, ...flat } = component;
      this.applyDynamicFields(flat, techComponentData);
      return flat;
    });
  }

  private isContactFieldType(type: string): boolean {
    if (!type) return false;
    const normalized = type.toLowerCase();
    return normalized === 'contact' || normalized === 'kontakt';
  }

  private applyDynamicFields(flat: any, techComponentData: any[] = []): void {
    techComponentData.forEach(dataField => {
      const fieldDef = this.componentTypeDataList.find(f => f.id === dataField?.techComponentTypeDataFieldId);
      if (fieldDef?.name) {
        flat[fieldDef.name] = this.isContactFieldType(fieldDef.type)
          ? this.resolveContactValue(dataField.dataValue)
          : dataField.dataValue;
      }
    });
  }

  private handleError(error: any): void {
    AppGlobals.ShowErrorMessage(error);
  }

  closePopup(): void {
    this.showDeleteRestrictionPopup = false;
    this.popupVisible = false;
    this.addNewComponentVisible = false;
    this.addComponentVisible = false;
    this.editComponentVisible = false;
    this.popupVisible = false;
    this.uploadDocumentVisible = false;
    this.reloadDataGrid();
    this.showFileUploadedName = false;
    this.fileUploadedName = '';
  }

  populateFilteredSites(componentId: number): void {
    const filtered = this.siteComponents.filter(sc => sc.componentId === componentId);
    this.filteredSiteIds = filtered.map(sc => sc.siteId);
    this.filteredSiteNames = filtered.map(sc => sc.siteName);
    this.filteredSiteQuantities = filtered.map(sc => sc.siteQuantity);
  }

  editComponent(): void {
    this.showForm();
    this.isEdit = true;
    this.selectedTypeId = this.componentInfo.typeId;
    this.componentId = this.componentInfo.componentId;
    this.appGlobals.$logItemId.next(this.componentId);
    this.populateFilteredProjects(this.componentId); // <-- Add this line
    this.populateFilteredSites(this.componentId);
    this.getDocsForThisComponent();
    const compObj = this.componentList.find(comp => comp.componentId === this.componentId);
    const techComponentData = compObj?.techComponentData || [];

    // if (this.componentInfo.model === null || this.componentInfo.model === undefined || this.componentInfo.model === '') {
    //   this.disableModel = false;
    // } else {
    //   this.disableModel = true;
    // }
    this.dynamicDataFields = this.componentTypeDataList
      .filter(field => Number(field.techComponentTypeId) === this.selectedTypeId)
      .map(field => {
        let options: string[] = [];
        if (Array.isArray(field.userDefinedOptionList) && field.userDefinedOptionList.length > 0) {
          try {
            options = JSON.parse(field.userDefinedOptionList[0]);
          } catch {
            options = [];
          }
        } else if (field.userDefinedOptionList && typeof field.userDefinedOptionList === 'string') {
          try {
            options = JSON.parse(field.userDefinedOptionList);
          } catch {
            options = [];
          }
        }
        const dataObj = techComponentData.find(
          d => d.techComponentTypeDataFieldId === field.id && d.techComponentId === this.componentId
        );

        return {
          ...field,
          dataValue: dataObj ? (dataObj.dataValue ?? '') : (field.dataValue ?? ''),
          options,
        };
      });

    this.compName = this.componentInfo.name;
    this.manufacturerId = this.componentInfo.manufacturerId;
    this.model = this.componentInfo.model;
    this.selectedStatus = this.componentInfo.status;
    this.isCompleted = !!this.componentInfo.isCompleted;
    this.isCompleting = false;
    this.disableType = true;
    // this.disableManufacturer = true;
  }

  showForm() {
    this.isGridHidden = true;
    this.isFormHidden = false;
  }

  hideForm() {
    this.isGridHidden = false;
    this.isFormHidden = true;
  }

  onDocFileSelected(e: any, doc: any): void {
    if (e.value && e.value.length > 0) {
      if (e.value[0].name.length > AppConfig.MaxFileNameLength) {
        AppGlobals.ShowErrorMessage(
          $localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`
        );

        return;
      }
      this.file = e.value[0];

      if (this.isEdit) {
        this.selectedComponentIdForDocUpload = this.selectedTypeId;
        this.uploadTechDocument(doc.id);
        setTimeout(() => {
          this.uploadDocId = null;
        }, 500);
      } else {
        this.pendingDocumentUploads.set(doc.id, this.file);
        this.uploadDocId = null; // Close the uploader popup
      }
    }
  }

  // Modified saveNewComponent with document validation and upload
  saveNewComponent(): void {
    this.showDuplicateMessage = false;
    // Mark missing required documents alongside the field hints on every save attempt.
    this.showMissingDocErrors = true;

    if (!this.techValidationGroup.instance.validate().isValid) {
      this.validationToast.showToast($localize`Please fill in all fields before saving`);
      return;
    }

    const requiredDocs = this.documentList.filter(
      doc => doc.techComponentTypeId === this.selectedTypeId && doc.required
    );
    const missingDocs = requiredDocs.filter(
      doc => !this.pendingDocumentUploads.has(doc.id)
    );

    if (this.isCompleting && missingDocs.length > 0) {
      this.showErrMsg = true;
      this.showMissingDocErrors = true;
      this.isCompleting = false;
      this.errMsg = $localize`:@@requiredDocsForCompletion:Please upload all required documents before completing the component.`;
      return;
    }

    // Step 1: Add component without DataFields
    const basePayload = {
      ComponentItem: {
        Id: null,
        ComponentId: null,
        ManufacturerId: this.manufacturerId,
        ManufacturerName: this.companies.find(c => c.id === this.manufacturerId)?.displayName || '',
        Name: this.compName,
        Type: this.selectedTypeName || '',
        TypeId: this.selectedTypeId,
        Model: this.model || '',
        HasDataSheet: this.selectedComponent.hasDataSheet || false,
        Quantity: this.selectedComponent.quantity || 1,
        IPAddress: this.selectedComponent.ipAddress || '',
        SerialNumber: this.selectedComponent.serialNumber || '',
        DataSheetName: this.selectedComponent.dataSheetName || '',
        Status: this.selectedStatus || 'Active',
        Deleted: this.selectedComponent.deleted || '',
        ComponentTypeId: this.selectedComponent.componentTypeId || this.selectedTypeId || null,
      },
      DataFields: [],
    };

    (async () => {
      try {
        const result = await this.technicalComponentsService.addTechComponent(basePayload);
        if (result.hasError === true) {
          if (result.feedback && result.feedback.trim() === 'Eine Komponente mit diesem Typ, Modell und Hersteller existiert bereits.') {
            this.validationToast.showToast(result.feedback);
          } else {
            AppGlobals.ShowErrorMessage(result.feedback);
          }
          return;
        }
        this.componentId = result.componentId;

        // Step 2: Build DataFields with correct componentId
        const dataFields = this.componentTypeDataList
          .filter(item => Number(item.techComponentTypeId) === Number(this.selectedTypeId))
          .map(item => {
            const dynField = this.dynamicDataFields.find(df => df.id === item.id);
            return {
              Id: null,
              TechComponentId: this.componentId,
              TechComponentTypeDataFieldId: item.id,
              DataValue:
                dynField && dynField.dataValue !== null && dynField.dataValue !== undefined
                  ? String(dynField.dataValue)
                  : '',
            };
          });

        // Step 3: Update component with DataFields
        const fullPayload = {
          ComponentItem: {
            ...basePayload.ComponentItem,
            ComponentId: this.componentId,
            IsCompleted: this.isCompleting
          },
          DataFields: dataFields,
        };
        await this.technicalComponentsService.editTechComponent(fullPayload);

        // Step 4: Create doc link entries
        this.writeDocsToTable();

        // Step 5: Upload all pending documents
        await this.uploadPendingDocuments();
        this.isCompleting = false;
        this.hideForm();
        this.reloadDataGrid();
        this.loadPageData();
        this.pendingDocumentUploads.clear();
        this.disableType = false;
        // this.disableManufacturer = false;
        // this.disableModel = false;
      } catch (error) {
        AppGlobals.ShowErrorMessage(error);
      }
    })();
  }

  // NEW: Upload all documents stored in memory
  async uploadPendingDocuments(): Promise<void> {
    const uploadPromises: Promise<void>[] = [];

    this.pendingDocumentUploads.forEach((file, docId) => {
      const formData = new FormData();
      formData.append('ComponentId', this.componentId.toString());
      formData.append('DocumentId', docId.toString());
      formData.append('Extension', file.name.split('.').pop() ?? '');
      formData.append('FileBytes', file);
      formData.append('FileBytesContentType', file.type);
      formData.append('FileBytesFileName', file.name);

      const uploadPromise = this.technicalComponentsService
        .addTechComponentDocument(formData)
        .then(result => {
          this.addDocUrl(result.documentName, docId);
        })
        .catch(error => {
          console.error(`Failed to upload document ${docId}:`, error);
          throw error;
        });

      uploadPromises.push(uploadPromise);
    });

    // Wait for all uploads to complete
    await Promise.all(uploadPromises);

    // Refresh doc links after all uploads
    setTimeout(() => {
      this.getAllDocLinks();
    }, 1000);
  }

  addNewComponent(): void {
    this.showDuplicateMessage = false;
    this.componentId = null;
    this.showForm();

    this.filteredSiteIds = [];
    this.filteredSiteNames = [];
    this.filteredSiteQuantities = [];
    this.filteredProjectIds = [];
    this.filteredProjectNames = [];
    this.filteredProjectQuantities = [];
    this.filteredProjectStatuses = [];
    this.siteQuantity = 0;

    if (this.selectedTypeId != null) {
      this.isComponentTypeSelected = true;

      // Populate dynamicDataFields for the selected type
      this.dynamicDataFields = this.componentTypeDataList
        .filter(field => Number(field.techComponentTypeId) === this.selectedTypeId)
        .map(field => {
          let options: string[] = [];
          if (Array.isArray(field.userDefinedOptionList) && field.userDefinedOptionList.length > 0) {
            try {
              options = JSON.parse(field.userDefinedOptionList[0]);
            } catch {
              options = [];
            }
          } else if (field.userDefinedOptionList && typeof field.userDefinedOptionList === 'string') {
            try {
              options = JSON.parse(field.userDefinedOptionList);
            } catch {
              options = [];
            }
          }
          return {
            ...field,
            dataValue: field.dataValue ?? '',
            options,
          };
        });
    } else {
      this.isComponentTypeSelected = false;
      this.dynamicDataFields = [];
    }

    this.manufacturerId = null;
    this.compName = '';
    this.model = '';
    this.isEdit = false;
    this.isCompleted = false;
    this.isCompleting = false;
    this.showMissingDocErrors = false;
    this.disableType = false;
    // this.disableManufacturer = false;
    // this.disableModel = false;
    this.pendingDocumentUploads.clear();
  }

  hasPendingUpload(docId: number): boolean {
    return this.pendingDocumentUploads.has(docId);
  }

  getPendingFileName(docId: number): string {
    const file = this.pendingDocumentUploads.get(docId);
    return file ? file.name : '';
  }

  removeCompDoc(doc: any): void {
    if (this.isEdit) {
      const existingDocLink = this.doclinks?.find(dl => dl.componentId === this.componentId && dl.docId === doc.id);
      if (!existingDocLink) return;

      this.technicalComponentsService.deleteTechComponentDocLink({ Id: existingDocLink.id }).then(result => {
        this.getAllDocLinks();
      });
    } else {
      // Create mode: Remove from memory
      this.pendingDocumentUploads.delete(doc.id);
    }
  }

  dropDownItems: any = {};
  componentTypeDataList: any = [];
  getDataFields(): void {
    this.technicalComponentsService.getAllComponentTypeDataField({}).then(result => {
      this.componentTypeDataList = result.componentTypeDataList;
      this.allDataFields = result.componentTypeDataList;
      this.dropDownItems = this.componentTypeDataList.userDefinedOptionList;

      // If editing, populate dynamicDataFields with dataValue from techComponentData
      if (this.isEdit && this.componentId != null) {
        const compObj = this.componentList.find(comp => comp.componentId === this.componentId);
        const techComponentData = compObj?.techComponentData || [];
        this.dynamicDataFields = this.componentTypeDataList
          .filter(field => Number(field.techComponentTypeId) === this.selectedTypeId)
          .map(field => {
            let options: string[] = [];
            if (Array.isArray(field.userDefinedOptionList) && field.userDefinedOptionList.length > 0) {
              try {
                options = JSON.parse(field.userDefinedOptionList[0]);
              } catch {
                options = [];
              }
            } else if (field.userDefinedOptionList && typeof field.userDefinedOptionList === 'string') {
              try {
                options = JSON.parse(field.userDefinedOptionList);
              } catch {
                options = [];
              }
            }
            const dataObj = techComponentData.find(d => d.techComponentTypeDataFieldId === field.id);
            return {
              ...field,
              dataValue: dataObj ? (dataObj.dataValue ?? '') : '',
              options,
            };
          });
      }
    });
  }

  componentPayload: any = [];

  saveTechComponent(): void {
    if (this.isEdit) {
      this.editTechComponent();
    } else {
      this.saveNewComponent();
    }
  }

  editTechComponent(): void {
    this.showDuplicateMessage = false;
    // Mark missing required documents alongside the field hints on every save attempt.
    this.showMissingDocErrors = true;

    if (!this.techValidationGroup.instance.validate().isValid) {
      this.validationToast.showToast($localize`Please fill in all fields before saving`);
      return;
    }

    const missingFields = this.dynamicDataFields.filter(
      field => field.required && (field.dataValue === null || field.dataValue === undefined || field.dataValue === '')
    );

    const missingDoc = this.dynamicDataFields.filter(
      field => field.required && (field.dataValue === null || field.dataValue === undefined || field.dataValue === '')
    );

    // --- Required document check ---
    const requiredDocs = this.documentList.filter(doc => doc.techComponentTypeId === this.selectedTypeId && doc.required);
    const missingDocs = requiredDocs.filter(doc => !this.doclinks?.find(dl => dl.docId === doc.id && dl.componentId === this.componentId && dl.docLink));

    if (this.isCompleting && missingDocs.length > 0) {
      this.showErrMsg = true;
      this.showMissingDocErrors = true;
      this.isCompleting = false;
      this.errMsg = $localize`:@@requiredDocsForCompletion:Please upload all required documents before completing the component.`;
      return;
    }

    const dataFields = this.dynamicDataFields.map(field => ({
      Id: null,
      TechComponentId: this.componentId,
      TechComponentTypeDataFieldId: field.id,
      DataValue: field.dataValue !== null && field.dataValue !== undefined ? String(field.dataValue) : '',
    }));

    this.componentPayload = {
      ComponentItem: {
        Id: null,
        ComponentId: this.componentId,
        ManufacturerId: this.manufacturerId,
        ManufacturerName: this.companies.find(c => c.id === this.manufacturerId)?.displayName || '',
        Name: this.compName,
        Type: this.selectedTypeName || this.typeName || this.componentInfo.type || '',
        TypeId: this.selectedTypeId,
        Model: this.model || '',
        HasDataSheet: this.selectedComponent.hasDataSheet || false,
        Quantity: this.selectedComponent.quantity || 1,
        IPAddress: this.selectedComponent.ipAddress || '',
        SerialNumber: this.selectedComponent.serialNumber || '',
        DataSheetName: this.selectedComponent.dataSheetName || '',
        Status: this.selectedStatus || 'Active' || 'Aktiv',
        Deleted: this.selectedComponent.deleted || '',
        ComponentTypeId: this.selectedComponent.componentTypeId || this.selectedTypeId || null,
        IsCompleted: this.isCompleted || this.isCompleting
      },
      DataFields: dataFields,
    };
    this.technicalComponentsService.editTechComponent(this.componentPayload).then(
      (result => {
        if (result.hasError === true) {
          if (result.feedback && result.feedback.trim() === "Eine Komponente mit diesem Namen existiert bereits.") {
            this.showDuplicateMessage = true;
          }
          this.isCompleting = false;
        } else {
          this.isCompleting = false;
          this.hideForm();
          this.disableType = true;
          // this.disableManufacturer = false;
          // this.disableModel = false;
          this.goBack();
          this.loadPageData();
          this.selectedTypeId = this.componentInfo.typeId;
          this.dynamicColumns = [];
          if (this.dataGrid?.instance) {
            this.dataGrid.instance.clearFilter();
          }
        }
      })
    );
  }

  reloadDataGrid(): void {
    let projectId = {
      ProjectId: this.projectId,
    };
    this.technicalComponentsService.getTechComponents(projectId).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.componentList = result.components;
          if (this.dataGrid?.instance) {
            this.dataGrid.instance.option('dataSource', this.componentList);
            this.dataGrid.instance.refresh();
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  doSearch(e: any): void {
    this.contentLoadedVisible = false;
    this.searchTerm = e.value;
    if (this.searchTerm.length < 2) {
      if (this.dataGrid) {
        this.dataGrid.instance.searchByText('');
        this.appGlobals.setSearchPanelText('');
        this.contentLoadedVisible = true;
      }
      return;
    }
    if (this.dataGrid) {
      this.dataGrid.instance.searchByText(this.searchTerm);
      this.appGlobals.setSearchPanelText(this.searchTerm);
      this.contentLoadedVisible = true;
    }
  }

  getAllSiteComponents(): void {
    this.technicalComponentsService.getAllComponentsForGridConnection({}).then(result => {
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.siteComponents = result.components;
      }
    });

    this.technicalComponentsService.getAllComponentsForProject({}).then(result => {
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.projectComponents = result.components;
      }
    });

    this.loadProjectStatusMap();
  }

  doclinks: any = {};
  getAllDocLinks(): void {
    this.technicalComponentsService.getAllDocumentLink({}).then(result => {
      this.doclinks = result.componentDocData;
    });
  }

  docUrl: string = '';
  async uploadTechDocument(docId: number): Promise<void> {
    if (!this.file) {
      AppGlobals.ShowErrorMessage('No file selected.');
      return;
    }

    const formData = new FormData();
    formData.append('ComponentId', this.componentId.toString());
    formData.append('DocumentId', docId.toString());
    formData.append('Extension', this.file.name.split('.').pop() ?? '');
    formData.append('FileBytes', this.file);
    formData.append('FileBytesContentType', this.file.type);
    formData.append('FileBytesFileName', this.file.name);

    this.technicalComponentsService.addTechComponentDocument(formData).then(
      result => {
        this.addDocUrl(result.documentName, docId);
        setTimeout(() => {
          this.getAllDocLinks();
        }, 2000);
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  addDocUrl(link: string, docId: number): void {
    const existingDocLink = this.doclinks?.find(dl => dl.componentId === this.componentId && dl.docId === docId);

    const payload = {
      Id: existingDocLink ? existingDocLink.id : null,
      TechComponentId: this.componentId,
      DocumentTypeId: docId,
      Link: link,
    };

    this.technicalComponentsService.addTechComponentDocLink(payload).then(result => {});
  }

  writeDocsToTable(): void {
    const docIds = this.documentList.filter(doc => doc.techComponentId === this.selectedTypeId).map(doc => doc.id);

    docIds.forEach(docId => {
      const payload = {
        Id: null,
        TechComponentId: this.componentId,
        DocumentTypeId: docId,
        Link: null,
      };
      this.technicalComponentsService.addTechComponentDocLink(payload).then(result => {});
    });
  }

  hasDocumentsForSelectedType(): boolean {
    return !!this.documentList?.some(doc => doc.techComponentTypeId === this.selectedTypeId);
  }

  /** Inline "required" hint under a document row - same cases as the required fields' hint. */
  isMissingRequiredDoc(doc: any): boolean {
    return !!doc?.required
      && !this.hasDocLink(doc)
      && (this.showMissingDocErrors || (this.isEdit && this.isCompleted));
  }

  hasDocLink(doc: any): boolean {
    if (!this.componentId || this.componentId === null) {
      return this.hasPendingUpload(doc.id);
    }

    return !!this.doclinks?.find(dl => dl.docId === doc.id && dl.componentId === this.componentId)?.docLink;
  }

  getDocForPill(doc: any): any {
    const link = this.doclinks?.find(dl => dl.docId === doc.id && dl.componentId === this.componentId);
    return { ...doc, docLink: link?.docLink, techDocId: link?.id, fileName: link?.fileName };
  }
  deleteComponent(): void {
    const payload = {
      ComponentItem: {
        ComponentId: this.componentId,
      },
    };
    this.technicalComponentsService.deleteTechComponent(payload).then(result => {
      if (result.hasError === true) {
        this.showDeleteRestrictionPopup = true;
      } else {
        // Hide all forms/popups
        this.addNewComponentVisible = false;
        this.editComponentVisible = false;
        this.isFormHidden = true;
        this.isGridHidden = false;
        this.popupVisible = false;
        this.detailsPanelVisible = false;
        this.selectedTypeId = null;

        // Optionally reset selected component
        this.selectedComponent = {
          manufacturerId: null,
          manufacturerName: null,
          type: null,
          model: null,
          powerRating: null,
          hasDataSheet: null,
          notes: null,
        };
        setTimeout(() => {
          this.reloadDataGrid();
        }, 1000);
      }
    });
  }

  disableDownloadAll: boolean = false;

  downloadZipped(): void {
    const componentId = this.componentId;
    this.technicalComponentsService.downloadAllComponentDocuments({ componentId }).then(result => {
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      this.apiFileService.downloadTempFile(result.downloadId, result.downloadFileName);
    });
  }

  downloadTechDoc(url: string): void {
    this.technicalComponentsService.downloadTechComponentDocumentByFileName({ FileName: url }).then(result => {
      this.downloadFileFromBytes(result.fileName, result.fileBytes, result.contentType);
    });
  }

  downloadFileFromBytes(fileName: string, base64Bytes: string, contentType: string): void {
    const binaryString = window.atob(base64Bytes);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  getDocTypeName(docId: number): string {
    const doc = this.documentList?.find(d => d.id === docId);
    return doc?.name || 'Document';
  }

  downloadLinks: any = [];
  getDocsForThisComponent(): void {
    const payload = {
      TechComponentId: this.componentId,
    };

    this.technicalComponentsService.getTechComponentDocs(payload, false).then(result => {
      this.downloadLinks = result.componentDocData;
      this.disableDownloadAll = this.filteredDownloadLinks.length === 0;
    });
  }

  get filteredDownloadLinks(): any[] {
    return this.downloadLinks.filter(dl => dl.docLink && dl.componentId === this.componentId);
  }

  getFileExtension(url: string): string {
    const match = url.match(/((\.[0-9a-z]+(?=[?#]))|(\.(?:\w+)))$/gi);

    return match ? match[0] : '';
  }

  contacts: any = {};
  getContacts(): void {
    Promise.all([this.contactService.getCompanies({}), this.contactService.getPersons({})]).then(
      ([companiesResult, personsResult]) => {
        this.companyList = companiesResult.companyItems;
        this.personsList = personsResult.personItems;
        this.contacts = {
          companies: this.companyList,
          persons: this.personsList,
        };
      }
    );
  }

  goToSite(siteId: any): void {
    this.ngZone.run(() => {
      this.router.navigate([`/site/${siteId}/infrastructure`]);
    });
  }

  uploadDocId: number = null;

  showUploaderForDoc(doc: any): void {
    this.uploadDocId = doc.id;
    this.docFileInput.nativeElement.click();
  }

  onDocFileInputChanged(e: any): void {
    const file = e.target?.files?.[0];
    if (file) {
      const doc = this.getDocById(this.uploadDocId);
      this.onDocFileSelected({ value: [file] }, doc);
    }
    // The input now persists across uploads (no longer recreated by an *ngIf popup each time),
    // so its value must be cleared manually or picking the same file twice in a row would not
    // fire another 'change' event.
    e.target.value = '';
  }

  getDocById(docId: number): any {
    return this.documentList.find(doc => doc.id === docId);
  }
  get dataFieldsForSelectedComponent(): any[] {
    if (!this.componentInfo || !this.componentInfo.typeId || !this.allDataFields) return [];
    return this.allDataFields.filter(field => Number(field.techComponentTypeId) === Number(this.componentInfo.typeId));
  }

  filteredProjectQuantities: number[] = [];

  populateFilteredProjects(componentId: number): void {
    const filtered = this.projectComponents.filter(pc => pc.componentId === componentId);
    this.filteredProjectIds = filtered.map(pc => pc.projectId);
    this.filteredProjectNames = filtered.map(pc => pc.projectName);
    this.filteredProjectQuantities = filtered.map(pc => pc.quantity);
    this.filteredProjectStatuses = filtered.map(pc => this.getProjectStatus(pc.projectId));
  }

  getSiteIdForProject(projectId: number): number | null {
    const projectComponent = this.projectComponents.find((item: any) => Number(item.projectId) === Number(projectId));
    return projectComponent ? projectComponent.siteId : null;
  }

  allComponentIds: number[] = [];
  downloadAllComponentDocsAsZip(): void {
    const componentIds = this.allComponentIds;
    this.technicalComponentsService.downloadAllComponentsDocumentsZipped({ componentIds }).then(result => {
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      this.apiFileService.downloadTempFile(result.downloadId, result.downloadFileName);
    });
  }

  viewCompDoc(doc: any): void {
    // 1. If editing and fileBytes are present
    if (doc.fileBytes && doc.contentType && doc.name) {
      const binaryString = window.atob(doc.fileBytes);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: doc.contentType });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      return;
    }

    // 2. If creating (file is in pendingDocumentUploads)
    if (this.pendingDocumentUploads && this.pendingDocumentUploads.has(doc.id)) {
      const file = this.pendingDocumentUploads.get(doc.id);
      const url = window.URL.createObjectURL(file);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      return;
    }

    // 3. If you have a docLink (URL to the file)
    const docLinkObj = this.doclinks?.find(dl => dl.docId === doc.id && dl.componentId === this.componentId);

    this.viewDoc(docLinkObj?.id, docLinkObj?.docLink, docLinkObj?.fileName);
  }

  viewDoc(docId: number, docLink: any, fileName?: string): void {
    if (docId) {
      this.fileViewerService.openOrDownloadFile('component', docId, docLink, undefined, fileName);
    }
  }

  componentDetails: any = {};
  async getComponentDetails(componentId: number): Promise<void> {
    const comp = this.componentList.find(c => c.componentId === componentId);
    if (comp) {
      this.selectedComponent = comp;
      const result = await this.technicalComponentsService.getComponentWithDatafields({ componentId }, false);
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      this.componentDetails = result.componentDetails;
      this.activityLog.logView({
        Section: ActivitySection.COMPONENTS,
        EntityType: ActivityEntity.COMPONENT,
        EntityId: componentId,
        EntityLabel: comp.name,
      });
      // Resolve contact composite keys to display names
      if (Array.isArray(this.componentDetails)) {
        this.componentDetails.forEach(detail => {
          if (Array.isArray(detail.dataFields)) {
            detail.dataFields.forEach(field => {
              field.value = this.resolveContactValue(field.value);
            });
          }
        });
      }
    }
  }

  calculateDynamicPageSize(): void {
    // Get the viewport height
    const viewportHeight = window.innerHeight;

    // Calculate available height for grid content
    // Subtract: header nav, page header, filters, bottom toolbar, margins
    const reservedSpace = 250; // Adjust based on your layout (header, filters, margins)
    this.availableHeight = viewportHeight - reservedSpace - this.toolbarHeight - 80;
    this.detailsPanelHeight = this.availableHeight;
    // Calculate how many rows can fit
    const contentHeight = this.availableHeight - this.headerHeight;
    const calculatedRows = Math.floor(contentHeight / this.rowHeight);

    // Set minimum of 10 rows, maximum of 1000
    this.dynamicPageSize = Math.max(10, Math.min(calculatedRows, 1000));

    // Update the grid if it's initialized
    if (this.dataGrid?.instance) {
      this.dataGrid.instance.pageSize(this.dynamicPageSize);
      this.dataGrid.instance.refresh();
      this.getGridPageInfo();
    }
  }

  openComponentFile(doc: any): void {
    // Example: doc contains fileType, fileId, fileName, fileUrl
    this.fileViewerService.openOrDownloadFile(
      doc.fileType, // e.g. 'component'
      doc.fileId, // e.g. doc.id or doc.componentId
      doc.fileName, // e.g. doc.name
      doc.fileUrl // e.g. doc.url or doc.docLink
    );
  }

  getTranslatedStatus(status: string): string {
    if (!status) return '';
    const normalized = status.trim().toLowerCase();
    if (normalized === 'active') return $localize`:@@active:Aktiv`;
    if (normalized === 'inactive') return $localize`:@@inactive:Inaktiv`;
    return status;
  }

  getStatusId(status: string): number {
    if (!status) return 1;
    const normalized = status.trim().toLowerCase();
    if (normalized === 'active') return 1;
    if (normalized === 'inactive') return 4;
    return 3;
  }

  goToPage(page: number): void {
    if (this.dataGrid?.instance && page >= 1 && page <= this.totalPages) {
      this.dataGrid.instance.pageIndex(page - 1);
      this.getGridPageInfo();
    }
  }

  getPaginationPages(): (number | string)[] {
    const pages: (number | string)[] = [];
    const current = this.currentPage;
    const total = this.totalPages;

    if (total <= 1) {
      return [1];
    }

    // Left group: previous page (if exists) + current page
    if (current > 1) {
      pages.push(current - 1);
    }
    pages.push(current);

    // Right group: second last + last page
    const secondLast = total - 1;
    const rightGroup: number[] = [];

    if (secondLast > current) {
      rightGroup.push(secondLast);
    }
    if (total > current) {
      rightGroup.push(total);
    }

    // Add separator and right group only if right group has pages
    if (rightGroup.length > 0) {
      pages.push('...');
      pages.push(...rightGroup);
    }

    return pages;
  }

  get sitesForPanel(): SiteInfo[] {
    if (!this.filteredSiteIds || this.filteredSiteIds.length === 0) return [];
    return this.filteredSiteIds.map((id, i) => ({
      id: id,
      name: this.filteredSiteNames[i],
      quantity: this.filteredSiteQuantities[i],
    }));
  }

  get projectsForPanel(): ProjectInfo[] {
    if (!this.filteredProjectIds || this.filteredProjectIds.length === 0) return [];
    return this.filteredProjectIds.map((id, i) => ({
      id: id,
      name: this.filteredProjectNames[i],
      siteId: this.getSiteIdForProject(id),
      quantity: this.filteredProjectQuantities[i],
      status: this.getProjectStatus(id),
    }));
  }

  onContactFieldSelected(field: any, event: any): void {
    if (event) {
      field.dataValue = `${event.type}:${event.data?.id}`;
    } else {
      field.dataValue = '';
    }
  }

  getContactIdForField(field: any): number | null {
    if (!field.dataValue || typeof field.dataValue !== 'string') return null;
    const parts = field.dataValue.split(':');
    if (parts.length === 2) {
      return Number(parts[1]) || null;
    }
    return null;
  }

  getContactTypeForField(field: any): string | null {
    if (!field.dataValue || typeof field.dataValue !== 'string') return null;
    const parts = field.dataValue.split(':');
    if (parts.length === 2) {
      return parts[0];
    }
    return null;
  }

  resolveContactValue(value: string): string {
    if (!value || typeof value !== 'string' || !value.includes(':')) return value;
    const parts = value.split(':');
    if (parts.length !== 2) return value;
    const type = parts[0];
    const id = Number(parts[1]);
    if (!id) return value;
    if (type === 'person') {
      const person = this.contacts.persons?.find(p => p.id === id);
      return person?.displayName || value;
    } else if (type === 'company') {
      const company = this.contacts.companies?.find(c => c.id === id);
      return company?.displayName || value;
    } else if (type === 'society') {
      const societies = this.societyService.contacts$.value;
      if (!societies) this.societyService.loadContacts(); // shown again once they're there
      const society = societies?.find(s => s.id === id);
      return society?.displayName || value;
    }
    return value;
  }

  onPageChange(page: number): void {
    if (this.dataGrid?.instance) {
      this.dataGrid.instance.pageIndex(page - 1);
      this.getGridPageInfo();
    }
  }

  completeComponent(): void {
    this.isCompleting = true;
    this.saveTechComponent();
  }

  showContactsPopup(): void {
    this.contactsPopupVisible = true;
  }

  onNewContactFromDropdown(type: string, context: 'manufacturer' | 'field', field?: any): void {
    if (context === 'manufacturer') {
      this.setManufacturerAsPopupTarget();
    } else {
      this.setPopupReturnTarget(field);
    }
    if (this.contactsPopup) {
      this.contactsPopup.popupSelectedTab = type === 'person' ? 1 : 0;
      this.contactsPopup.editMode = true;
      this.contactsPopup.openedDirectlyInEditMode = true;
    }
    this.showContactsPopup();
  }

  setPopupReturnTarget(field: any): void {
    this.popupReturnTarget = field;
  }

  onPopupContactSelected(e: any): void {
    if (this.isPopupForManufacturer) {
      this.manufacturerId = e.data?.id ?? e.id ?? null;
      this.isPopupForManufacturer = false;
      this.contactsPopupVisible = false;
      return;
    }
    if (!this.popupReturnTarget) return;
    if (e.data) {
      this.popupReturnTarget.dataValue = `${e.type}:${e.data.id}`;
    } else {
      this.popupReturnTarget.dataValue = `${e.type}:${e.id}`;
    }
    this.contactsPopupVisible = false;
  }

  onManufacturerContactSelected(event: any): void {
    this.manufacturerId = event ? (event.data?.id ?? null) : null;
  }

  setManufacturerAsPopupTarget(): void {
    this.popupReturnTarget = null;
    this.isPopupForManufacturer = true;
  }

  onRowPrepared(e: any): void {
    if (e.rowType !== 'data') return;

    if (e.data?.status?.toLowerCase() === 'inactive') {
      e.rowElement.classList.add('component-inactive');
    }

    const isSelected = this.detailsPanelVisible && e.data?.componentId === this.componentId;
    e.rowElement.classList.toggle('selected-component-row', isSelected);
  }
}
